<template>
    <div>
        <video
                id="videoplay"
                src="../assets/guan.mp4"
                loop="loop"
                autoplay="autoplay"
                muted
                width="1"
                height="1"
                poster="../assets/guan2.jpg"
        ></video>
        <div class='popContainer'>
            <div class="rollback" @click="rollback()">

            </div>
            <div class="times">
                {{currentTime}}
            </div>
        </div>
        <div class="changeNum">
            <div style="overflow: hidden">
                <p style="float: left">液位深度：{{bulk}} cm</p>
                <div style="width: 80px;height: 10px;border: 1px solid silver;float: left;margin-top: 0px;margin-left: 5px">
                    <div :style="{width:bulk2}" style="height: 10px;background: rgb(153,22,255)"></div>
                </div>
            </div>
            <div style="overflow: hidden;margin-top: 40px">
                <p style="float: left">液位体积：{{high}} L</p>
                <div style="width: 80px;height: 10px;border: 1px solid silver;float: left;margin-top: 0px;margin-left: 5px">
                    <div :style="{width:high2}" style="height: 10px;background: rgb(153,22,255)"></div>
                </div>
            </div>
        </div>
        <div class="goBack" @click="rollback()">

        </div>
    </div>
</template>

<script>
	export default {
		name: "stockpile",
		data(){

			return{
				timer: "",
				timer2: "",
				currentTime: '',
                high: 0,//液位高度
                bulk: 0,//液位体积
				high2:0,
				bulk2:0
			}
		},
		methods: {
			rollback(){
				this.$router.push('/navigation')
			}
		},
		created() {
			var _this = this;
			var times
			var now = new Date();
			var day = now.getDay();
			_this.timer = setInterval(function() {
				let  shi= new Date().getHours()
				let  fen= new Date().getMinutes()
				shi= shi <= 9 ? "0"+ shi : shi
				fen= fen <= 9 ? "0"+ fen : fen
				times =
					new Date().getFullYear() +
					"-" +
					(new Date().getMonth() + 1) +
					"-" +
					new Date().getDate() +
					" " +
					shi +
					":" +
					fen
				_this.currentTime= times
			}, 1000);
			if(day==1){
				_this.bulk = 210
				_this.high = 30
            }else {
				_this.bulk = 210-24*(day-1)
				_this.high = Math.floor(30-30/7*(day-1))
            }
			_this.bulk2=_this.bulk/3 + 'px'
			_this.high2=Math.floor(_this.high*2.4)+ 'px'
		},
		beforeDestroy() {
			if (this.timer) {
				clearInterval(this.timer); // 在Vue实例销毁前，清除我们的定时器
				clearInterval(this.timer2); // 在Vue实例销毁前，清除我们的定时器
			}
		}
	}
</script>

<style scoped>
    .goBack{
        width: 20%;
        height: 250px;
        /*background: crimson;*/
        position: absolute;
        top: 76%;
        left: 80%;
        right: 0;
        bottom: 0;
        overflow: hidden;
    }
    #videoplay {
        width: 100%;
        height: 100%;
        object-fit: fill;
        border-radius: 5px;
        position: relative;
    }
    .popContainer{
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0,0,0,0);
        width: 100%;
        height: 100px;
        color: cornsilk;
        z-index: 100;
    }
    .popContainer .rollback{
        width: 150px;
        height: 100px;
        /*background-color: red;*/
        position: absolute;
        top: 10px;
        left: 20px;
        right: 0;
        bottom: 0;
    }
    .popContainer .times{
        height: 20px;
        position: absolute;
        top: 80%;
        left: 80%;
        right: 0;
        bottom: 0;
    }
    .changeNum{
        height: 200px;
        width: 400px;
        /*background-color: red;*/
        color: aliceblue;
        position: absolute;
        top: 70%;
        left: 79%;
        right: 0;
        bottom: 0;
    }
</style>



// WEBPACK FOOTER //
// src/views/stockpile.vue